var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.982,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98633 3.47095C6.6504 3.46509 11.3145 3.47095 15.9785 3.48853C16.2226 3.50552 16.4453 3.58169 16.6465 3.71704C14.4023 5.36921 12.1523 7.01568 9.89648 8.65649C9.28712 9.10182 8.67772 9.10182 8.06836 8.65649C5.81259 7.01568 3.56259 5.36921 1.31836 3.71704C1.5267 3.58623 1.74935 3.5042 1.98633 3.47095Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4905 5.1582C17.5373 6.60527 17.5608 8.06425 17.5608 9.53516C17.5549 10.9941 17.5491 12.4531 17.5432 13.9121C17.3925 14.8246 16.8593 15.346 15.9436 15.4766C11.303 15.5 6.66235 15.5 2.02173 15.4766C1.10605 15.346 0.572849 14.8246 0.42212 13.9121C0.404542 11.0059 0.398681 8.09962 0.404542 5.19336C0.468118 5.19304 0.526713 5.21062 0.580323 5.24609C3.13501 7.10938 5.68969 8.97266 8.24439 10.8359C8.73657 11.1406 9.22876 11.1406 9.72095 10.8359C12.3172 8.94815 14.907 7.05559 17.4905 5.1582Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessge);
export default __webpack_public_path__ + "static/media/messge.0ccd4d5e698b9c9744d69241f1f77d98.svg";
export { ForwardRef as ReactComponent };